import { render, staticRenderFns } from "./TenantUserForm.vue?vue&type=template&id=8b0fa074"
import script from "./TenantUserForm.vue?vue&type=script&lang=js"
export * from "./TenantUserForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports